<mon-page-toolbar
  titleTranslateKey="monitoring.menu.404"
  [showFiltersButton]="false"
/>

<a routerLink="/">Home</a>
